import { ref } from 'vue'

// Shared display-only state, without importing API clients or application setup.
export const displayLocale = ref<'zh-CN' | 'en-US'>('zh-CN')
